module.exports = __webpack_public_path__ + "static/media/2pic.022e3dae.png";